import styled from 'styled-components';
const StyledServiceListContainer = styled.div``;
export default StyledServiceListContainer;